<template>
  <div class="modal" v-show="isShow">
    <div class="modal-container">
      <div class="modal-header">
        <div class="modal-close" @click="close()"></div>
        <p class="modal-title">{{ title }}</p>
      </div>
      <div class="modal-body">
        <p class="modal-msg">{{ msg }}</p>
        <a :href="link.url" class="modal-link">
          <img :src="link.img" alt="" class="modal-link-img">
          <div class="modal-link-content">
            <p class="modal-link-title">{{ link.title }}</p>
            <p class="modal-link-desc">{{{ link.desc }}}</p>
          </div>
          <div class="modal-link-right">
            <span class="modal-link-arrow"></span>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modal',
  props: ['title', 'msg', 'link'],
  data() {
    return {
      isShow: false
    }
  },
  methods: {
    open() {
      this.isShow = true
    },
    close() {
      this.isShow = false
    },
  }
}
</script>

<style lang="sass">
@import "../../../../sass/base/_abbrev.scss";

.modal {
	position: fixed;
	top: 0;
	bottom: 0;
	right: 0;
	left: 0;
	background-color: rgba(0, 0, 0, .5);
  z-index: 99;

	* {
		box-sizing: border-box;
	}

	&-container {
		position: absolute;
		top: 50%;
		left: 50%;
		width: rem(600);
		border-radius: rem(20);
		background-color: #fff;
		transform: translate(-50%, -50%);
	}

	&-header {
    padding-top: rem(60);
    padding-bottom: rem(44);
    font-size: rem(32);
		text-align: center;
		color: #fa961b;
    border-top-right-radius: rem(20);
	}

	&-close {
		position: absolute;
		top: 0;
		left: 0;
		width: rem(80);
    height: rem(80);
		background-image: url('../../../../img/xhpopulrz/common/close.png');
		background-size: cover;
		transform: translate(-36%, -36%);
	}

	&-body {
    padding: rem(55) rem(40) rem(50);
	}

	&-msg {
    margin-bottom: rem(32);
    font-size: rem(28);
		color: #999;
	}

	&-link {
		display: flex;
    padding: rem(20);
    width: rem(518);
    height: rem(164);
    border-radius: rem(20);
		border: 1px solid #e6e6e6;
    background-color: #f6f6f6;

		&-img {
      width: rem(120);
      height: rem(120);
      border-radius: rem(20);
      margin-right: rem(40);
		}

		&-content {
      width: rem(270);
		}

		&-right {
			position: relative;
		}

		&-arrow {
			position: absolute;
			display: block;
			top: 50%;
			transform: translateY(-50%);
      width: rem(26);
      height: rem(45);
			background-image: url('../../../../img/xhpopulrz/common/right.png');
			background-size: cover;
		}

		&-title {
      font-size: rem(32);
			color: #333;
			line-height: 1.5;
		}

		&-desc {
			font-size: rem(26);
			color: #999;
			line-height: 1.5;
		}
	}
}
</style>



// WEBPACK FOOTER //
// modal.vue?df36f302